import ClayForm from '@clayui/form';
import classNames from 'classnames';
import {ReactNode} from 'react';
import BaseWarning from "./BaseWarning";

type BaseWrapperProps = {
    id: string;
    children: ReactNode;
    description?: string;
    error?: string;
    label?: string;
    groupClassName?: string;
    required?:boolean;
    disabled?:boolean;
};

export default function BaseWrapper (props: BaseWrapperProps) {
    return (
        <ClayForm.Group
            className={classNames(
                'form-group',
                 props.groupClassName,
                {
                    'has-error': props.error,
                    'group-disabled': props.disabled
                }
            )}
        >
            {props.label && (
                <label
                    htmlFor={props.id}
                >
                    {props.label}
                    {props.required && <span className="text-danger"> *</span>}
                </label>
            )}

            {props.children}

            {props.description && (
                <small className="form-text text-muted" id="Help">
                    {props.description}
                </small>
            )}

            {props.error && <BaseWarning>{props.error}</BaseWarning>}
        </ClayForm.Group>
    );
};
